export default {
	app: false,
	urlApis: null,
	access: false,
	asideStorage:[],
	selectedItem: null,
}
